import { Box, ColorOptions, Icon, ModBox, Text } from '@jfs/ui-new'
import { FC } from 'react'
interface Prop {
  onProceed: () => void
  onBack: () => void
  currentStep: number
  title?: string
  isLoading: boolean
}

interface StepsItemProps {
  title: string
  index: number
  stepState: keyof typeof StepState | Array<keyof typeof StepState>
  steps: any[]
  onStepPressed?: (step: number) => null
}

const StepState = {
  ACTIVE: 'active',
  DISABLE: 'disable',
  COMPLETED: 'completed',
  FAILED: 'failed',
}

const StepsItem = ({ title, stepState, index, steps, onStepPressed }: StepsItemProps) => {
  const handleStepPressed = () => {
    onStepPressed(index + 1)
  }
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      bg={stepState === 'ACTIVE' ? ('#0070B614' as ColorOptions) : 'TRANSPARENT'}
      onPress={stepState === 'COMPLETED' ? handleStepPressed : null}
      underlayColor={'#0070B614' as ColorOptions}>
      <Box flexDirection={'column'} align={'center'} ph={16} h={48}>
        <Box w={'1'} h={16} bg={'BRAND_PRIMARY_GREEN'} opacity={0.2} />
        <Box
          w={16}
          h={16}
          borderColor={
            stepState === 'FAILED' && steps.length - 1 === index ? 'BRAND_PRIMARY_RED' : 'BLUE_SHADE_PRIMARY'
          }
          borderRadius={8}
          borderWidth={stepState === 'COMPLETED' ? 0 : 1}
          opacity={stepState === 'ACTIVE' || stepState === 'COMPLETED' ? 1 : stepState === 'FAILED' ? 1 : 0.2}
          backgroundColor={stepState === 'FAILED' && steps.length - 1 === index ? 'BRAND_PRIMARY_RED' : undefined}
          justify={'center'}
          align={'center'}>
          {stepState === 'COMPLETED' && <Icon id={'SUCCESSFUL_FILLED'} size={16} color={'BRAND_PRIMARY_GREEN'} />}
          {stepState === 'FAILED' && steps.length - 1 === index && <Icon id={'CLOSE'} size={10} color={'WHITE'} />}
        </Box>
        <ModBox show={index < steps.length - 1} w={'1'} h={16} bg={'BRAND_PRIMARY_GREEN'} opacity={0.2} />
      </Box>
      <Text
        title={title}
        color={stepState === 'ACTIVE' || stepState === 'COMPLETED' ? 'BLUE_SHADE_PRIMARY' : 'PRIMARY_GREY'}
        fontFamily={'jiotype-medium'}
        fontSize={12}
      />
    </Box>
  )
}

const VerticalStepIndicator: FC<any> = ({ currentStep, steps, submitState, onStepPressed }: any) => {
  return (
    <Box
      bg={'#0070B60A' as ColorOptions}
      f={1}
      w={220}
      borderRightWidth={1}
      borderRightColor={'#0000001F' as ColorOptions}
      overflow={'auto'}>
      {steps.map((item: any, index: number) => {
        return (
          <StepsItem
            stepState={
              currentStep === index + 1
                ? currentStep === steps.length
                  ? submitState
                    ? submitState
                    : 'COMPLETED'
                  : 'ACTIVE'
                : currentStep < index + 1
                ? 'DISABLE'
                : 'COMPLETED'
            }
            title={item}
            index={index}
            steps={steps}
            onStepPressed={onStepPressed}
            key={index}
          />
        )
      })}
    </Box>
  )
}

export { VerticalStepIndicator }
